var _path, _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgOptimismBc = function SvgOptimismBc(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 94,
    height: 94,
    viewBox: "0 0 94 94",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3139_121286",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 94,
    height: 94
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 0H94V94H0V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3139_121286)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.15386 75.6281C8.63554 78.1935 13.102 79.4764 18.5536 79.4764C25.1507 79.4764 30.4188 77.9416 34.3587 74.8723C38.2985 71.7572 41.0701 67.0614 42.6734 60.7851C43.6354 56.9372 44.4602 52.9743 45.1472 48.8971C45.3765 47.4311 45.4911 46.2171 45.4911 45.255C45.4911 42.0484 44.6891 39.2995 43.0857 37.0091C41.4824 34.6726 39.2836 32.9316 36.489 31.7864C33.6943 30.5955 30.5335 30 27.006 30C14.0413 30 6.00129 36.299 2.8862 48.8971C1.7868 53.524 0.93936 57.4869 0.343515 60.7851C0.114626 62.2511 0 63.4882 0 64.496C0 69.3064 1.71795 73.017 5.15386 75.6281ZM26.0439 67.3134C24.2571 68.8252 22.0814 69.5811 19.5156 69.5811C15.118 69.5811 12.9189 67.4738 12.9189 63.2589C12.9189 62.2511 13.0104 61.289 13.1939 60.3731C14.0183 55.9293 14.843 52.1726 15.6677 49.1033C16.4463 45.9882 17.7292 43.6748 19.5156 42.1626C21.3482 40.6509 23.547 39.895 26.1128 39.895C30.4646 39.895 32.6407 41.9795 32.6407 46.1483C32.6407 47.1565 32.5491 48.1412 32.366 49.1033C31.8163 52.31 31.0143 56.0667 29.9607 60.3731C29.1821 63.4882 27.8765 65.8016 26.0439 67.3134Z",
    fill: "white",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47.4782 78.3083C47.7529 78.6292 48.1426 78.7896 48.6465 78.7896H57.9921C58.4499 78.7896 58.8854 78.6292 59.2977 78.3083C59.7097 77.9875 59.9617 77.5755 60.0536 77.0716L63.2145 62.0224H72.4913C78.4926 62.0224 83.2114 60.7626 86.6473 58.243C90.129 55.7233 92.4425 51.8293 93.5876 46.5608C93.8627 45.3241 94 44.1327 94 42.9875C94 39.0019 92.4425 35.9557 89.327 33.8481C86.2577 31.7408 82.1805 30.6872 77.0955 30.6872H58.8165C58.3584 30.6872 57.9233 30.8476 57.5109 31.1681C57.0986 31.4889 56.8466 31.9012 56.755 32.4052L47.272 77.0716C47.1805 77.5297 47.249 77.9417 47.4782 78.3083ZM77.9887 50.9588C76.5685 52.0124 74.8963 52.5394 72.9725 52.5394H65.0698L67.681 40.239H75.9272C77.8056 40.239 79.1339 40.6053 79.9128 41.3384C80.6918 42.0255 81.0811 43.0333 81.0811 44.362C81.0811 44.9575 81.0122 45.6445 80.8749 46.4235C80.4168 48.3934 79.4547 49.9051 77.9887 50.9588Z",
    fill: "white",
    fillOpacity: 0.2
  }))));
};

export { SvgOptimismBc as ReactComponent };
export default __webpack_public_path__ + "5bb82875a11b601813183b02e5501c48.svg";